import accessibleAutocomplete from 'accessible-autocomplete'
import { DigitalMarketplaceFrontendComponent } from '../../digitalmarketplace-frontend-component'

class SelectCountryFromForm implements DigitalMarketplaceFrontendComponent {
  static moduleName = 'dm-select-country-from-form'

  $module: JQuery<HTMLElement>

  constructor ($module: JQuery<HTMLElement>) {
    this.$module = $module
  }

  init () {
    accessibleAutocomplete.enhanceSelectElement({
      selectElement: this.$module.get(0)
    })
  }
}

export { SelectCountryFromForm }
